module.exports = __webpack_public_path__ + "static/media/mulher_r1_c3.15b51ca1.jpg";